t = require('views/internal/teacup-with-helpers')('board_power_ups')

module.exports = t.renderable ({ partOfTeam, upgradeUrl, hasGold, onOldBC }) ->
  t.h4 '.power-ups-upgrade-header', ->
    t.format 'exceeded-power-ups-limit'
  if hasGold
    t.p '.power-ups-upgrade-text', ->
      t.format 'as-a-gold-member-three-power-ups'
  else if onOldBC
    # They're on an old version of BC, so we don't want to say that
    # they aren't paying at all
    t.p '.power-ups-upgrade-text', ->
      t.format 'with-the-legacy-version-of-business-class-you-can-turn-on-one-power-up-per-board'
  else if partOfTeam
    # The board is in a team so we want to sell them on BC
    t.p '.power-ups-upgrade-text', ->
      t.format 'business-class-teams-get-unlimited-power-ups'
  else
    t.p '.power-ups-upgrade-text', ->
      t.format 'as-a-free-member-one-power-up'
  t.p '.power-ups-upgrade-text', ->
    t.format 'power-ups-exceeds-your-limit'
  if onOldBC
    t.p '.power-ups-upgrade-text', ->
      t.format 'to-unlock-more-upgrade-your-team-to-the-latest-version-of-business-class-today'
  else
    t.p '.power-ups-upgrade-text', ->
      t.format 'continue-using-upgrade-to-bc'
  t.div '.power-ups-upgrade-action', ->
    if partOfTeam
      t.a '.button.primary', { href: upgradeUrl }, ->
        t.format 'lets-do-this'
    else
      t.button '.button.primary.js-upgrade', ->
        t.format 'lets-do-this'
  t.div '.power-ups-upgrade-action', ->
    t.a '.power-ups-upgrade-cancel.js-go-back', href: '#', ->
      t.format 'no-thanks'




// WEBPACK FOOTER //
// ./app/scripts/views/templates/power_ups_upgrade.coffee